export const DEFAULT_SURVEY_TAB = "survey";

export const SURVEY_TAB_IDS = [
  "survey",
  "files",
  "soa",
  "results",
  "deployments",
  "templates",
];

export function isValidSurveyTab(tab) {
  if (!tab) return false;
  return SURVEY_TAB_IDS.includes(tab);
}

export function surveyPath(tab = DEFAULT_SURVEY_TAB) {
  const safeTab = isValidSurveyTab(tab) ? tab : DEFAULT_SURVEY_TAB;
  return `/survey/${safeTab}`;
}

export function parseSurveyLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "survey") {
    return { tab: DEFAULT_SURVEY_TAB };
  }
  const tab = parts[1] || DEFAULT_SURVEY_TAB;
  return { tab: isValidSurveyTab(tab) ? tab : DEFAULT_SURVEY_TAB };
}
